import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "@/providers";
import { handleMsalChildWindow } from "@/service/auth";
import { useUserStore } from "@/service/user";
import { Loader } from "@/shared/ui";
import { queryClient } from "./shared/lib";
import { AppRoutes } from "./router";

import "./index.css";
import { CustomHttpError } from "./shared/utills";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.VITE_APP_ENV,

  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,

  beforeSend(event, hint) {
    const originalError = hint.originalException;

    if (!event.tags?.error_domain) {
      if (originalError instanceof CustomHttpError) {
        event.tags = {
          ...event.tags,
          error_domain: "http",
        };
      } else {
        event.tags = {
          ...event.tags,
          error_domain: "ui",
        };
      }
    }

    return event;
  },
});

// во всплывающем окне и iframe MSAL приложение не запускаем: только пересылаем ответ Microsoft
if (!handleMsalChildWindow()) {
  // init не бросает: ошибка входа уходит в store.error и показывается на экране логина
  void useUserStore.getState().init();

  const root = ReactDOM.createRoot(document.getElementById("root")!!);

  root.render(
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Toaster position="top-right" richColors />
            {/* страницы lazy: без границы Suspense синхронный рендер (вход/выход меняют стор) падает в ErrorBoundary */}
            <Suspense fallback={<Loader fullPage />}>
              <AppRoutes />
            </Suspense>
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>,
  );
}
